export type GlobalFontPreset = {
  key: string
  label: string
  family: string
}

export const GLOBAL_FONT_PRESETS: GlobalFontPreset[] = [
  {
    key: 'roboto',
    label: 'Roboto',
    family: "'Roboto', 'Helvetica Neue', Arial, sans-serif",
  },
  {
    key: 'open-sans',
    label: 'Open Sans',
    family: "'Open Sans', 'Helvetica Neue', Arial, sans-serif",
  },
  {
    key: 'lato',
    label: 'Lato',
    family: "'Lato', 'Helvetica Neue', Arial, sans-serif",
  },
  {
    key: 'montserrat',
    label: 'Montserrat',
    family: "'Montserrat', 'Helvetica Neue', Arial, sans-serif",
  },
  {
    key: 'poppins',
    label: 'Poppins',
    family: "'Poppins', 'Helvetica Neue', Arial, sans-serif",
  },
  {
    key: 'nunito-sans',
    label: 'Nunito Sans',
    family: "'Nunito Sans', 'Helvetica Neue', Arial, sans-serif",
  },
  {
    key: 'inter',
    label: 'Inter',
    family: "'Inter', 'Helvetica Neue', Arial, sans-serif",
  },
  {
    key: 'ibm-plex-sans',
    label: 'IBM Plex Sans',
    family: "'IBM Plex Sans', 'Helvetica Neue', Arial, sans-serif",
  },
  {
    key: 'jetbrains-mono',
    label: 'JetBrains Mono',
    family: "'JetBrains Mono', 'SF Mono', 'Menlo', monospace",
  },
]

export const DEFAULT_GLOBAL_FONT_PRESET = GLOBAL_FONT_PRESETS[0]

export const resolveGlobalFontPreset = (fontFamily: unknown): GlobalFontPreset => {
  const normalized = String(fontFamily || '').trim().toLowerCase()
  if (!normalized) return DEFAULT_GLOBAL_FONT_PRESET

  return GLOBAL_FONT_PRESETS.find((preset) =>
    preset.key === normalized
    || preset.label.toLowerCase() === normalized
    || preset.family.toLowerCase() === normalized,
  ) || DEFAULT_GLOBAL_FONT_PRESET
}
